import { aboutContent } from '@/mocks/articles';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOJsonLd from '@/components/feature/SEOJsonLd';

export default function AboutPage() {
  return (
    <>
      <SEOJsonLd
        pageType="AboutPage"
        pageUrl="/about"
        pageTitle="关于我们 - 爱情岛论坛网址导航"
        pageDescription="爱情岛论坛网址导航的品牌介绍、信誉说明与联系方式。专注提供爱情岛论坛最新官方入口与地址导航服务。"
        dateModified="2026-08-05"
      />

      <div className="relative h-[220px] md:h-[280px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20warm%20abstract%20composition%20with%20soft%20rose%20gold%20and%20cream%20gradients%2C%20minimalist%20design%2C%20clean%20editorial%20aesthetic%2C%20no%20text%2C%20peaceful%20harmonious%20atmosphere%2C%20gentle%20flowing%20shapes&width=1600&height=500&seq=about-hero-01&orientation=landscape"
          alt="关于我们"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 flex items-center">
          <div className="max-w-7xl mx-auto px-4 md:px-6 w-full">
            <h1 className="font-heading text-2xl md:text-3xl font-bold text-white">
              关于我们
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="py-8">
          <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
            品牌介绍
          </h2>
          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            {aboutContent.brandIntro.split('\n\n').map((para, idx) => (
              <p
                key={idx}
                className="text-sm text-foreground-600 leading-relaxed mb-3 last:mb-0"
              >
                {para}
              </p>
            ))}
          </div>
        </section>

        <section className="py-8">
          <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
            信誉说明
          </h2>
          <div className="bg-background-100 rounded-lg p-6 md:p-8">
            {aboutContent.reputation.split('\n\n').map((para, idx) => (
              <div key={idx}>
                {para.split('\n').map((line, lineIdx) => (
                  <p
                    key={lineIdx}
                    className="text-sm text-foreground-600 leading-relaxed mb-2 last:mb-0"
                  >
                    {line}
                  </p>
                ))}
              </div>
            ))}
          </div>
        </section>

        <section className="py-8 pb-16">
          <h2 className="font-heading text-xl font-semibold text-foreground-950 mb-4">
            联系方式
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-background-100 rounded-lg p-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-950">
                  {aboutContent.contact.email}
                </p>
              </div>
            </div>
            <div className="bg-background-100 rounded-lg p-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">微信</p>
                <p className="text-sm font-medium text-foreground-950">
                  {aboutContent.contact.wechat}
                </p>
              </div>
            </div>
            <div className="bg-background-100 rounded-lg p-5 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                <i className="ri-qq-line text-secondary-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500 mb-0.5">QQ</p>
                <p className="text-sm font-medium text-foreground-950">
                  {aboutContent.contact.qq}
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}